<template>
  <div>
    <div class="row pb-5">
      <div class="col-12 col-lg-8">
        <div class="pb-4"><top-stories-panel /></div>
        <div class="pb-4"><news-by-interests /></div>
        <div class="pb-4"><resources-panel ref="resourcesPanel" /></div>
      </div>
      <div class="col-12 col-lg-4 pl-lg-2">
        <div class="pb-4"><right-panel /></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as CONSTANTS from "@/store/constants";

import TopStoriesPanel from "./news/TopStoriesPanel";
import RightPanel from "./RightPanel";
import ResourcesPanel from "./resources/ResourcesPanel";
import NewsByInterests from "./newsByInterests/NewsByInterests";
import FirstTimeVisitModal from "./modals/FirstTimeVisitModal";

export default {
  name: "homebase-home",
  components: {
    TopStoriesPanel,
    RightPanel,
    ResourcesPanel,
    NewsByInterests,
    FirstTimeVisitModal,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {
    // impersonation
    "user.userName": function () {
      this.$refs.resourcesPanel.getResources();
    },
  },
  created() {
    this.checkShowFirstTimeVisitModal();
  },
  methods: {
    checkShowFirstTimeVisitModal() {
      let userHasVisited = window.localStorage.getItem(CONSTANTS.AONE_FIRST_TIME_VISIT_KEY);
      if (!userHasVisited) {
        this.showFirstTimeVisitModal();
      }
    },
    showFirstTimeVisitModal() {
      this.$modal.show(
        FirstTimeVisitModal,
        {},
        {
          adaptive: true,
          scrollable: true,
          width: 880,
          height: "auto",
        }
      );
    },
  },
};
</script>

<style scoped>
/* force adjust column sizes */
@media (min-width: 992px) {
  .col-lg-4 {
    -ms-flex: 0 29%;
    -webkit-box-flex: 0;
    flex: 0 0 29%;
    max-width: 29%;
  }
  .col-lg-8 {
    -ms-flex: 0 71%;
    -webkit-box-flex: 0;
    flex: 0 0 71%;
    max-width: 71%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/HomebaseHome.vue